import { render, staticRenderFns } from "./customerPoint.vue?vue&type=template&id=fb18e428&scoped=true"
import script from "./customerPoint.vue?vue&type=script&lang=js"
export * from "./customerPoint.vue?vue&type=script&lang=js"
import style0 from "./customerPoint.vue?vue&type=style&index=0&id=fb18e428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb18e428",
  null
  
)

export default component.exports